import {regNavn} from "../tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {l} from "../../../types/typescriptdefinisjoner_lederplan";

//ng2 ekvivalent: src/scripts/felles-ng2/tjenester/i18n/EnumOversettelser.ts
export class EnumOversettelser  {

    static regNavn = "EnumOversettelser";

    static forInjisering = () => {
        return [
            regNavn.gettext.gettextCatalog,
            EnumOversettelser
        ]
    };


    constructor( private gettextCatalog: gettextCatalog) {
    }

    public oversettInvitasjonsstatus(status: l.Invitasjonsstatus) {
        switch (status) {
            case l.Invitasjonsstatus.ikke_sendt:
                /// Invitasjonsstatus.ikke_sendt
                return this.gettextCatalog.getString("Ikke sendt");
            case l.Invitasjonsstatus.sendt:
                /// Invitasjonsstatus.sendt
                return this.gettextCatalog.getString("Sendt");
            case l.Invitasjonsstatus.akseptert:
                /// Invitasjonsstatus.akseptert
                return this.gettextCatalog.getString("Godtatt");
            case l.Invitasjonsstatus.avslått:
                /// Invitasjonsstatus.avslått
                return this.gettextCatalog.getString("Avslått");
            default:
                return status;
        }
    }

    public oversettMedlemsstatus(status: l.Medlemstatus) {
        switch (status) {
            case l.Medlemstatus.normal_tilgang:
                /// Medlemstatus.normal_tilgang
                return this.gettextCatalog.getString("Normal tilgang");
            case l.Medlemstatus.tilgang_stengt:
                /// Medlemstatus.tilgang_stengt
                return this.gettextCatalog.getString("Tilgang stengt");
            case l.Medlemstatus.anonymisert:
                /// Medlemstatus.anonymisert
                return this.gettextCatalog.getString("Permanent deaktivert");
            default:
                return status;
        }
    }

    public oversettOppgaveStatus(status: l.Oppgavestatus) {
        switch (status) {
            case l.Oppgavestatus.ikke_påbegynt:
                return this.gettextCatalog.getString("Ikke påbegynt");
            case l.Oppgavestatus.påbegynt:
                return this.gettextCatalog.getString("Påbegynt");
            case l.Oppgavestatus.utført:
                return this.gettextCatalog.getString("Utført");
        }
        return status;
    }

    public oversettAgendadokumentDel(del: l.AgendadokumentDel) {
        switch (del) {
            case l.AgendadokumentDel.saksbeskrivelse:
                return this.gettextCatalog.getString("Saksbeskrivelse");
            case l.AgendadokumentDel.beslutningsforslag:
                return this.gettextCatalog.getString("Beslutningsforslag");
            case l.AgendadokumentDel.planlagte_deltakere:
                return this.gettextCatalog.getString("Planlagte deltakere");
        }
        return del;
    }

    public oversettDokumentForelder(del: l.OppgaveForelderType) {
        switch (del) {
            case l.OppgaveForelderType.gruppe:
                return this.gettextCatalog.getString("Frittstående oppgaver i gruppen");
            case l.OppgaveForelderType.sak:
                return this.gettextCatalog.getString("Oppgaver knyttet til saker");
            case l.OppgaveForelderType.beslutning:
                return this.gettextCatalog.getString("Oppgaver knyttet til beslutninger");
        }
        return del;
    }

}
